import { defineComponent as n, computed as a, createElementBlock as s, openBlock as d, renderSlot as v } from "vue";
import { RAW_DIMENSION as i, getSize as m } from "./Icon.constant.js";
const u = ["aria-hidden", "aria-label", "height", "role", "viewBox", "width"], f = /* @__PURE__ */ n({
  name: "RevIcon",
  __name: "Icon",
  props: {
    size: { default: "24" },
    viewBox: { default: `0 0 ${i} ${i}` },
    alternativeText: { default: void 0 }
  },
  setup(r) {
    const t = r, o = a(() => m(t.size)), l = a(() => t.alternativeText ? "img" : void 0);
    return (e, c) => (d(), s("svg", {
      "aria-hidden": !e.alternativeText,
      "aria-label": e.alternativeText,
      fill: "currentColor",
      height: o.value,
      role: l.value,
      viewBox: e.viewBox,
      width: o.value,
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      v(e.$slots, "default")
    ], 8, u));
  }
});
export {
  f as default
};
